var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 15.5237C25.0271 17.9224 23.7311 20.0899 21.901 21.7521C20.071 23.4144 17.789 24.4966 15.3438 24.862C12.8985 25.2274 10.3998 24.8596 8.16366 23.805C5.92751 22.7504 4.05436 21.0565 2.7811 18.9374C1.50785 16.8183 0.891692 14.3693 1.01055 11.9C1.12941 9.43079 1.97795 7.05225 3.44885 5.06522C4.91976 3.0782 6.94695 1.57194 9.27406 0.736961C11.6012 -0.098023 14.1237 -0.224232 16.5225 0.374296C19.7385 1.17671 22.5041 3.22344 24.2111 6.06438C25.9181 8.90532 26.4267 12.3078 25.625 15.5237Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 3.77881L13.3828 4.17626V15.7117L13.4997 15.8286L18.8547 12.6633L13.4997 3.77881Z",
    fill: "#343434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 3.77881L8.14453 12.6633L13.4995 15.8286V3.77881Z",
    fill: "#8C8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 16.8421L13.4336 16.9227V21.0315L13.4999 21.224L18.858 13.6787L13.4999 16.8421Z",
    fill: "#3C3C3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 21.224V16.8421L8.14453 13.6787L13.4995 21.224Z",
    fill: "#8C8C8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15.8278L18.855 12.6626L13.5 10.2285V15.8278Z",
    fill: "#141414"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14453 12.6631L13.4995 15.8283V10.229L8.14453 12.6631Z",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.0eac7f384ec7649b8f0d86ddf2af15d1.svg";
export { ForwardRef as ReactComponent };